export const TrendDownIcon = () => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M5 9.66668L7.8 6.86668L8.86667 8.46668L11 6.33334'
            stroke='#039855'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M6.3335 9.66668H5.00016V8.33334'
            stroke='#039855'
            strokeWidth='1.3'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M9.99984 14.6667H5.99984C2.6665 14.6667 1.33317 13.3333 1.33317 10V6.00001C1.33317 2.66668 2.6665 1.33334 5.99984 1.33334H9.99984C13.3332 1.33334 14.6665 2.66668 14.6665 6.00001V10C14.6665 13.3333 13.3332 14.6667 9.99984 14.6667Z'
            stroke='#039855'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
